class FSMobileMenu {
  constructor() {
    this.mobileMenuToggle = document.getElementById('fs-mobile-menu-toggle');
    this.mobileMenu = document.querySelector('.fs-mobile-menu');
    this.body = document.body;
    this.openDropdowns = new Set();
    
    this.init();
  }

  init() {
    if (this.mobileMenuToggle) {
      this.mobileMenuToggle.addEventListener('click', this.toggleMobileMenu.bind(this));
    }

    // Initialize mobile dropdowns
    this.initMobileDropdowns();

    // Close mobile menu when clicking outside
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    
    // Close mobile menu on escape key
    document.addEventListener('keydown', this.handleEscapeKey.bind(this));
  }

  initMobileDropdowns() {
    const dropdownTriggers = document.querySelectorAll('[data-mobile-dropdown-trigger]');
    
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.handleDropdownToggle.bind(this));
    });
  }

  handleDropdownToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const trigger = event.currentTarget;
    const dropdownId = trigger.getAttribute('data-mobile-dropdown-trigger');
    const dropdown = document.querySelector(`[data-mobile-dropdown="${dropdownId}"]`);
    
    if (!dropdown) return;
    
    const isCurrentlyOpen = this.openDropdowns.has(dropdownId);
    
    // Only close siblings at the same level, not parent dropdowns
    this.closeSiblingDropdowns(trigger);
    
    if (isCurrentlyOpen) {
      this.closeDropdown(dropdownId, trigger);
    } else {
      this.openDropdown(dropdownId, trigger);
    }
  }

  closeSiblingDropdowns(currentTrigger) {
    // Find the parent dropdown container
    const parentDropdown = currentTrigger.closest('.fs-mobile-dropdown');
    if (!parentDropdown) return;
    
    // Close all dropdowns at the same level within the same parent
    const siblingTriggers = parentDropdown.querySelectorAll('[data-mobile-dropdown-trigger]');
    siblingTriggers.forEach(sibling => {
      if (sibling !== currentTrigger) {
        const siblingId = sibling.getAttribute('data-mobile-dropdown-trigger');
        this.closeDropdown(siblingId, sibling);
      }
    });
  }

  openDropdown(dropdownId, trigger) {
    const dropdown = document.querySelector(`[data-mobile-dropdown="${dropdownId}"]`);
    if (!dropdown) return;
    
    // Add classes for styling
    dropdown.classList.add('fs-mobile-dropdown--open');
    trigger.classList.add('fs-mobile-menu__nav-item--expanded');
    
    // Add to open dropdowns set
    this.openDropdowns.add(dropdownId);
    
    // If it's a submenu item, also add expanded class
    if (trigger.classList.contains('fs-mobile-dropdown__item--expandable')) {
      trigger.classList.add('fs-mobile-dropdown__item--expanded');
    }
  }

  closeDropdown(dropdownId, trigger) {
    const dropdown = document.querySelector(`[data-mobile-dropdown="${dropdownId}"]`);
    if (!dropdown) return;
    
    // Remove classes for styling
    dropdown.classList.remove('fs-mobile-dropdown--open');
    trigger.classList.remove('fs-mobile-menu__nav-item--expanded');
    
    // Remove from open dropdowns set
    this.openDropdowns.delete(dropdownId);
    
    // If it's a submenu item, also remove expanded class
    if (trigger.classList.contains('fs-mobile-dropdown__item--expandable')) {
      trigger.classList.remove('fs-mobile-dropdown__item--expanded');
    }
    
    // Close any nested dropdowns
    const nestedDropdowns = dropdown.querySelectorAll('[data-mobile-dropdown]');
    nestedDropdowns.forEach(nested => {
      const nestedId = nested.getAttribute('data-mobile-dropdown');
      const nestedTrigger = document.querySelector(`[data-mobile-dropdown-trigger="${nestedId}"]`);
      if (nestedTrigger) {
        this.closeDropdown(nestedId, nestedTrigger);
      }
    });
  }

  closeAllDropdowns() {
    this.openDropdowns.forEach(dropdownId => {
      const dropdown = document.querySelector(`[data-mobile-dropdown="${dropdownId}"]`);
      const trigger = document.querySelector(`[data-mobile-dropdown-trigger="${dropdownId}"]`);
      if (dropdown && trigger) {
        this.closeDropdown(dropdownId, trigger);
      }
    });
  }

  toggleMobileMenu() {
    if (this.mobileMenu) {
      this.mobileMenu.classList.toggle('fs-mobile-menu--open');
      this.body.classList.toggle('fs-mobile-menu-open');
      
      // Toggle hamburger icon
      const hamburgerIcon = this.mobileMenuToggle.querySelector('svg');
      if (hamburgerIcon) {
        hamburgerIcon.classList.toggle('hamburger--open');
      }
    }
  }

  handleOutsideClick(event) {
    if (this.mobileMenu && this.mobileMenu.classList.contains('fs-mobile-menu--open')) {
      if (!this.mobileMenu.contains(event.target) && !this.mobileMenuToggle.contains(event.target)) {
        this.closeMobileMenu();
      }
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape' && this.mobileMenu && this.mobileMenu.classList.contains('fs-mobile-menu--open')) {
      this.closeMobileMenu();
    }
  }

  closeMobileMenu() {
    if (this.mobileMenu) {
      this.mobileMenu.classList.remove('fs-mobile-menu--open');
      this.body.classList.remove('fs-mobile-menu-open');
      
      // Close all dropdowns when closing mobile menu
      this.closeAllDropdowns();
      
      // Reset hamburger icon
      const hamburgerIcon = this.mobileMenuToggle.querySelector('svg');
      if (hamburgerIcon) {
        hamburgerIcon.classList.remove('hamburger--open');
      }
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FSMobileMenu();
});
